import { AnyAction } from 'redux';
import { ProgressbarItem } from '../../app/progressbar/data/progressbarItem';

export const rubrikenReducer = function (
  sectionState: Array<ProgressbarItem> = null,
  action: AnyAction,
): Array<ProgressbarItem> {
  switch (action.type) {
    default:
      return sectionState;
  }
};
